import React from 'react'
import logo from 'images/logo-mato-njavro.svg'

const Logo = () => {
  return <img src={logo} alt="Mato Njavro" />
}

export default Logo
